import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('rm/purchase-order/drafts', { params })
  },

  async show (id) {
    return axios.get(`rm/purchase-order/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('rm/purchase-order/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`rm/purchase-order/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`rm/purchase-order/drafts/${data.id}`, { data })
  }
}

export default DraftService
